<template>
    <div id="app">
        <div class="header-fixed">
            <FubonHeader :menu="menu" :hasContent="hasContent" />
        </div>
        <div class="fixed-margin">
            <SubHeader :show="show" />
            <!-- <p class="warningText text-center p-1">*疫情期間建議遠距諮詢</p> -->
            <div class="content">
                <router-view/>
            </div>
        </div>
        <FubonFooter />
        <Notification />
    </div>
</template>

<script>
import SubHeader from '@/components/SubHeader.vue';
import Notification from '@/components/Notification.vue';
import { request } from '@/service';
export default {
    name: 'APP',
    components: {
        SubHeader,
        Notification,
    },
    created() {
        this.getMenu();
        this.$store.dispatch('setHasContent', true);
    },
    computed: {
        show() {
            return this.$store.state.subHeaderShow;
        },
        hasContent: {
            get() {
                return this.$store.state.hasContent;
            },
            set(value) {
                this.value = value;
            }
        }
    },
    data() {
        return {
            menu: [],
        };
    },
    watch: {
        hasContent(newValue) {
            this.hasContent = newValue;
        }
    },
    methods: {
        getMenu() {
            request({
                method: 'GET',
                api: '/api/getMenu',
                base: true,
            })
                .then(res => {
                    const menu = [];
                    res.data.menuTree.forEach(item => {
                        const json = {
                            title: item.title,
                            link: item.link,
                            gaStr: item.gastr,
                            children: item.children.length === 0 ? null : item.children,
                        };
                        menu.push(json);
                    });
                    this.menu = menu;
                }).catch((error) => {
                    this.$notify({
                        group: 'alert',
                        title: error.message,
                        type: 'error',
                    });
                });
        }
    }
};
</script>

<style lang="scss">
#app {
    font-family: Microsoft JhengHei, Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
    position: relative;
    .header-fixed {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        z-index: 1000;
        background-color: #fff;
    }
    .warningText {
        color: #FF7601;
        background-color: #FCF8EE;
    }
}
a {
    cursor: pointer;
}
.error {
    font-size: 0.8125rem;
    color: $danger;
}
.fixed-margin {
    margin-top: 70px;
    min-height: calc(100vh - 70px - 94px);
}
@media (max-width: 767px) {
    .fixed-margin {
        margin-top: 70px;
        min-height: calc(100vh - 62px - 118px);
    }
}
@media (max-width: 768px) {
    .fixed-margin {
        margin-top: 50px;
        min-height: calc(100vh - 50px - 142px);
    }
}
@media (max-width: 363px) {
    .fixed-margin {
        margin-top: 50px;
        min-height: calc(100vh - 50px - 166px);
    }
}
.content {
    margin: auto;
    max-width: 540px;
}
.button {
    min-width: 150px;
    height: 45px;
}
//bootstrap change
.custom-select,
.form-control {
    border-color: #707070 !important;
    &:focus {
        border-color: $primary !important;
    }
}
.custom-select:disabled {
    font-weight: bold !important;
}
.was-validated
    .custom-control-input:valid:focus
    ~ .custom-control-label::before,
.custom-control-input.is-valid:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 0.2rem rgba(0, 137, 209, 0.25) !important;
}
.form-control.is-valid,
.was-validated .form-control:valid {
    border-color: initial !important;
    box-shadow: none !important;
    background: #fff !important;
}
.custom-select.is-valid:focus,
.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
    border-color: $primary !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 137, 209, 0.25) !important;
}
.was-validated .custom-control-input:valid ~ .custom-control-label,
.custom-control-input.is-valid ~ .custom-control-label {
    color: #333 !important;
}
.was-validated
    .custom-control-input:valid:checked
    ~ .custom-control-label::before,
.custom-control-input.is-valid:checked ~ .custom-control-label::before {
    background-color: $primary !important;
}
::placeholder {
    color: #b2b2b2 !important;
}
.custom-control-label {
    font-size: 18px !important;
    padding-top: 3px !important;
}
.custom-control-inline {
    margin-right: 0.5rem !important;
}
@media (max-width: 320px) {
    .custom-control-inline {
        margin-right: 0.2rem !important;
    }
}
@media (max-width: 350px) {
    .custom-control-label {
        font-size: 1rem !important;
    }
}
.custom-control-label::before {
    border-color: #707070 !important;
}
.custom-control-input:checked ~ .custom-control-label::before {
    border-color: $primary !important;
}

.form-control:disabled,
.form-control[readonly] {
    background-color: #f5f5f5 !important;
    border-color: #dddddd !important;
    font-weight: bold;
    color: #999;
}
.custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
    color: #6c757d !important;
}
.custom-control-input[disabled] ~ .custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
    border-color: #dddddd !important;
}
.custom-checkbox
    .custom-control-input:disabled:checked
    ~ .custom-control-label::before {
    background-color: rgba(0, 123, 255, 0.5) !important;
}
.btn.btn-primary.rounded-pill {
    background: linear-gradient(to right, $primary 5%, #01b6d2 95%) !important;
    border-color: transparent !important;
}
.btn-primary:focus,
.btn-primary.focus {
    box-shadow: none !important;
}
select:disabled {
    opacity: 0.7 !important;
    border-color: rgba(118, 118, 118, 0.3) !important;
    background-color: #f5f5f5 !important;
}
.modal-header .close {
    padding: 0px 8px !important;
    font-size: 40px !important;
}
.modal-lg {
    max-width: 600px !important;
}
.modal-dialog {
    margin-top: 80px !important;
}
.custom-select.is-invalid,
.form-control.is-invalid,
.was-validated .form-control:invalid {
    border-color: #dc3545 !important;
}
</style>
